export default __webpack_public_path__ + "static/media/Bolts of Conflagration.0502eadc.jpg";